import http from '../../http/http'
import type { LoginPayload, LoginResponse, RegisterPayload, RegisterResponse } from '../types/auth.types'

export const login = (params: LoginPayload): Promise<LoginResponse> => 
  http.post('/auth/login', params).then((res) => res.data)

export const register = (params: RegisterPayload): Promise<RegisterResponse> =>
  http.post('/auth/register', params).then((res) => res.data)
